// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Db-Lr","importantInfo":"styles_importantInfo__YYYsQ"};